module.exports = __webpack_public_path__ + "img/img-qcode.18773697.png";